const guavaPulpData = {
  hero_section: {
    title: "Premium Guava Pulp Collection",
    description: "100% Natural • No Preservatives • Rich in Vitamin C",
    src: "videos/guava-processing.webm",
  },
  description: {
    title: "Premium Guava Pulp Collection",
    main_description:
      "Discover our range of 100% natural guava pulp, crafted from the finest guava varieties to preserve the authentic tropical flavors and high nutritional value.",
    segment_description:
      "Perfect for beverages, jams, and food processing applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Guava Pulp",
    description: "Our guava pulp collection offers different varieties to meet diverse application needs. Rich in Vitamin C and natural sweetness, our guava pulps are perfect for beverages, jams, and food processing.",
    image: "New-Images/Guava.png",
    mainFeatures: [
      "High Vitamin C content",
      "Natural sweetness profile",
      "Multiple color varieties available",
      "Perfect for beverages and jams",
      "Premium quality processing",
      "Consistent texture and flavor"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "90",
      fat: "0g",
      carbs: "15g (Sugar: 14g, Added: 10g)",
      fiber: "8g",
      protein: "<1g",
      sodium: "0mg",
      potassium: "255mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Pink Guava Pulp",
      image: "New-Images/Guava.png",
      features: [
        "Premium pink variety",
        "High vitamin C content",
        "Natural sweetness",
        "Perfect for beverages"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    },
    {
      id: "2",
      name: "White Guava Pulp",
      image: "New-Images/Guava.png",
      features: [
        "Mild flavor profile",
        "High fiber content",
        "Versatile applications",
        "Consistent quality"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Guava Pulp Excellence",
    description: "Our guava pulp is processed from the finest handpicked guavas using advanced processing techniques. We maintain strict quality control to ensure consistent taste, texture, and nutritional value in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Food Industry",
    subline: "From beverages to jams – authentic guava flavor in every application!",
    description:
      "Ideal for juice manufacturers, jam producers, confectionery makers, and food service providers who demand consistent quality and authentic taste.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Perfect for guava juices, smoothies, and tropical drink mixes with consistent flavor and color.",
    },
    {
      id: 2,
      image: "jam-applications.webp",
      title: "Jam & Preserve Applications",
      description:
        "Ideal for jams, jellies, and preserves requiring authentic guava taste and natural sweetness.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Food Service",
      description:
        "Excellent for restaurants, cafes, and catering services looking for premium guava ingredients.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural guava goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Versatile Applications",
      image: "versatile-applications.webp",
      title: "Versatile Applications",
      description:
        "Suitable for beverages, jams, confectionery, and food service applications",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Guava Pulp",
    description: "Discover the perfect blend of quality, consistency, and authentic flavors that make our guava pulp the preferred choice for food manufacturers worldwide.",
  },
};

export default guavaPulpData;
